import TrainChatbot from "../../assets/TrainChatbot.png";
import TalkToSupport from "../../assets/TalkToSupport.png";
import { useState } from "react";
import GoogleCalendarWidget from "../Demo/GoogleCalendarWidget";
export default function SalesChatbotBenefit() {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const openCalendar = () => {
      setIsCalendarOpen(true);
    };
  return (
    <>
    <div className="mt-16 mb-8 md:mb-12 flex flex-col gap-16 text-[15px] text-gray-700">
      <section className="overflow-hidden">
        <div className="sm:mx-[6%] mx-[4%]">
          <div className="mx-auto grid justify-center max-w-2xl grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-5 sm:gap-y-12 sm:gap-y-12 lg:mx-0 lg:max-w-none">
            <div className="hidden lg:block order-2">
              <div className="flex lg:justify-start items-center lg:items-end">
                <img
                  src={TrainChatbot}
                  alt="sales-chatbot-software"
                  className="object-cover h-auto w-auto max-h-[700px] mt-4"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="order-1 ">
              <div className="sm:p-8 p-4 bg-gray-100 rounded-[8px] flex flex-col justify-center gap-4">
                <div className="text-[16px] font-semibold text-[#06526d]">
                  Enhance Your Sales Strategy
                </div>
                <p className="text-gray-700 font-bold text-[17px] sm:text-[21px] md:text-[23px] lg:text-[34px]">
                  Unlock the Power of Sales Chatbot for Your Business
                </p>
                <p className="mt-2 leading-6 sm:leading-8">
                  Boost Sales Efficiency with AI-Driven Chatbot Solutions
                </p>
                <dl className="mt-4 sm:mt-5 max-w-xl space-y-4 leading-6 lg:max-w-none">
                  <div className="relative pl-9">
                    <dt className="inline font-semibold">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="#06526d"
                        aria-hidden="true"
                        className="absolute left-1 top-1 h-5 w-5 text-[#06526d]"
                      >
                        <path d="M3.196 12.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 12.87z"></path>
                        <path d="M3.196 8.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 8.87z"></path>
                        <path d="M10.38 1.103a.75.75 0 00-.76 0l-7.25 4.25a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.76 0l7.25-4.25a.75.75 0 000-1.294l-7.25-4.25z"></path>
                      </svg>
                      Effortless Chatbot Training
                    </dt>
                    <dd className="ml-1 inline">
                      Train your chatbot using website content, file uploads,
                      raw text, or custom Q&A pairs, with upcoming integrations
                      for Slack, Dropbox, and Drive to make training even more
                      flexible.
                    </dd>
                  </div>
                  <div className="relative pl-9">
                    <dt className="inline font-semibold">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="#06526d"
                        aria-hidden="true"
                        className="absolute left-1 top-1 h-5 w-5 text-[#06526d]"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.5 17a4.5 4.5 0 01-1.44-8.765 4.5 4.5 0 018.302-3.046 3.5 3.5 0 014.504 4.272A4 4 0 0115 17H5.5zm3.75-2.75a.75.75 0 001.5 0V9.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0l-3.25 3.5a.75.75 0 101.1 1.02l1.95-2.1v4.59z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      Automated Lead Capture
                    </dt>
                    <dd className="ml-1 inline">
                      Capture vital visitor details like email, name, phone, and
                      interests during AI chats, and seamlessly sync leads into
                      Legitt CRM or your existing CRM for follow-ups and
                      conversions.
                    </dd>
                  </div>
                  <div className="relative pl-9">
                    <dt className="inline font-semibold">
                      <img
                        src="https://d2qb2qddg7l6c6.cloudfront.net/legitt-website-v5/assets/images/icons/custom.png"
                        alt="Custom Icon"
                        className="absolute left-1 top-1 h-5 w-5 text-[#06526d]"
                      />
                      Visitor Insights Dashboard
                    </dt>
                    <dd className="ml-1 inline">
                      Monitor visitor behavior, website analytics, and
                      engagement patterns through an intuitive dashboard for
                      real-time decision-making.
                    </dd>
                  </div>

                  <div className="relative pl-9">
                    <dt className="inline font-semibold">
                      <svg
                        xmlns="https://d2qb2qddg7l6c6.cloudfront.net/legitt-website-v5/assets/images/icons/custom.png"
                        viewBox="0 0 20 20"
                        fill="#06526d"
                        aria-hidden="true"
                        className="absolute left-1 top-1 h-5 w-5 text-[#06526d]"
                      >
                        <path
                          fillRule="evenodd"
                          d="M14.5 10a4.5 4.5 0 004.284-5.882c-.105-.324-.51-.391-.752-.15L15.34 6.66a.454.454 0 01-.493.11 3.01 3.01 0 01-1.618-1.616.455.455 0 01.11-.494l2.694-2.692c.24-.241.174-.647-.15-.752a4.5 4.5 0 00-5.873 4.575c.055.873-.128 1.808-.8 2.368l-7.23 6.024a2.724 2.724 0 103.837 3.837l6.024-7.23c.56-.672 1.495-.855 2.368-.8.096.007.193.01.291.01zM5 16a1 1 0 11-2 0 1 1 0 012 0z"
                          clipRule="evenodd"
                        ></path>
                        <path d="M14.5 11.5c.173 0 .345-.007.514-.022l3.754 3.754a2.5 2.5 0 01-3.536 3.536l-4.41-4.41 2.172-2.607c.052-.063.147-.138.342-.196.202-.06.469-.087.777-.067.128.008.257.012.387.012zM6 4.586l2.33 2.33a.452.452 0 01-.08.09L6.8 8.214 4.586 6H3.309a.5.5 0 01-.447-.276l-1.7-3.402a.5.5 0 01.093-.577l.49-.49a.5.5 0 01.577-.094l3.402 1.7A.5.5 0 016 3.31v1.277z"></path>
                      </svg>
                      Balanced Automation and Personalization
                    </dt>
                    <dd className="ml-1 inline">
                      Decide how many AI agents will handle conversations and
                      how many human agents will step in, ensuring the perfect
                      blend of automation and personal interaction.
                    </dd>
                  </div>
                </dl>
                <div className="mt-4 sm:mt-5 flex flex-col sm:flex-row items-center justify-center sm:justify-start gap-x-2 gap-y-2">
                  <button
                    onClick={openCalendar}
                    className="px-3 py-1 contained"
                  >
                    Get A Demo
                  </button>
                  <a href="https://legittmateai.com/legitt-pro/app/login">
                    <button className="text">Start for free</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="overflow-hidden">
        <div className="sm:mx-[6%] mx-[4%]">
          <div className="mx-auto grid justify-center max-w-2xl grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-5 sm:gap-y-12 sm:gap-y-12 lg:mx-0 lg:max-w-none">
            <div className="hidden lg:block">
              <div className="flex justify-end order-2 lg:order-1 items-center lg:items-end">
                <img
                  src="https://legittmateai.com/assets/TalkToSupport-BMEsyVcK.png"
                  alt="sales-chatbot-software"
                  className="object-cover h-auto w-auto max-h-[580px]"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="lg:pt-4 order-1 lg:order-2">
              <div className="sm:p-8 p-4 bg-gray-100 rounded-[8px] flex flex-col justify-center gap-4">
                <div className="text-[16px] font-semibold text-[#06526d]">
                  Transform Your Sales Process
                </div>
                <p className="text-gray-700 font-bold text-[17px] sm:text-[21px] md:text-[23px] lg:text-[34px]">
                  AI-Powered Sales Chatbot
                </p>
                <p className="mt-2 leading-6 sm:leading-8">
                  Revolutionizing Sales Interactions with Automated
                  Conversations.
                </p>
                <dl className="mt-4 sm:mt-5 max-w-xl space-y-4 leading-6 lg:max-w-none">
                  <div className="relative pl-9">
                    <dt className="inline font-semibold">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="#06526d"
                        aria-hidden="true"
                        className="absolute left-1 top-1 h-5 w-5 text-[#06526d]"
                      >
                        <path d="M3.196 12.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 12.87z"></path>
                        <path d="M3.196 8.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 8.87z"></path>
                        <path d="M10.38 1.103a.75.75 0 00-.76 0l-7.25 4.25a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.76 0l7.25-4.25a.75.75 0 000-1.294l-7.25-4.25z"></path>
                      </svg>
                      Sales Associate Efficiency
                    </dt>
                    <dd className="ml-1 inline">
                      Empower sales associates with tools to engage in live
                      conversations, prioritize quality leads, and focus on
                      high-value interactions, saving time and boosting
                      productivity.
                    </dd>
                  </div>
                  <div className="relative pl-9">
                    <dt className="inline font-semibold">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="#06526d"
                        aria-hidden="true"
                        className="absolute left-1 top-1 h-5 w-5 text-[#06526d]"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.5 17a4.5 4.5 0 01-1.44-8.765 4.5 4.5 0 018.302-3.046 3.5 3.5 0 014.504 4.272A4 4 0 0115 17H5.5zm3.75-2.75a.75.75 0 001.5 0V9.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0l-3.25 3.5a.75.75 0 101.1 1.02l1.95-2.1v4.59z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      Interactive Visitor Map
                    </dt>
                    <dd className="ml-1 inline">
                      Gain deeper insights with a state-of-the-art map that
                      tracks visitor locations, website journeys, and behaviors,
                      supported by meaningful filters for precision targeting.
                    </dd>
                  </div>
                  <div className="relative pl-9">
                    <dt className="inline font-semibold">
                      <img
                        src="https://d2qb2qddg7l6c6.cloudfront.net/legitt-website-v5/assets/images/icons/custom.png"
                        alt="Custom Icon"
                        className="absolute left-1 top-1 h-5 w-5 text-[#06526d]"
                      />
                      Intuitive Embedding
                    </dt>
                    <dd className="ml-1 inline">
                      Quickly embed your chatbot with a simple JavaScript
                      snippet, making deployment effortless and efficient.
                    </dd>
                  </div>

                  <div className="relative pl-9">
                    <dt className="inline font-semibold">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="#06526d"
                        aria-hidden="true"
                        className="absolute left-1 top-1 h-5 w-5 text-[#06526d]"
                      >
                        <path
                          fillRule="evenodd"
                          d="M14.5 10a4.5 4.5 0 004.284-5.882c-.105-.324-.51-.391-.752-.15L15.34 6.66a.454.454 0 01-.493.11 3.01 3.01 0 01-1.618-1.616.455.455 0 01.11-.494l2.694-2.692c.24-.241.174-.647-.15-.752a4.5 4.5 0 00-5.873 4.575c.055.873-.128 1.808-.8 2.368l-7.23 6.024a2.724 2.724 0 103.837 3.837l6.024-7.23c.56-.672 1.495-.855 2.368-.8.096.007.193.01.291.01zM5 16a1 1 0 11-2 0 1 1 0 012 0z"
                          clipRule="evenodd"
                        ></path>
                        <path d="M14.5 11.5c.173 0 .345-.007.514-.022l3.754 3.754a2.5 2.5 0 01-3.536 3.536l-4.41-4.41 2.172-2.607c.052-.063.147-.138.342-.196.202-.06.469-.087.777-.067.128.008.257.012.387.012zM6 4.586l2.33 2.33a.452.452 0 01-.08.09L6.8 8.214 4.586 6H3.309a.5.5 0 01-.447-.276l-1.7-3.402a.5.5 0 01.093-.577l.49-.49a.5.5 0 01.577-.094l3.402 1.7A.5.5 0 016 3.31v1.277z"></path>
                      </svg>
                      Customizable Design
                    </dt>
                    <dd className="ml-1 inline">
                      Personalize your chatbot’s appearance to match your
                      website’s branding, providing a seamless and professional
                      user experience.
                    </dd>
                  </div>
                </dl>
                <div className="mt-4 sm:mt-5 flex flex-col sm:flex-row items-center justify-center sm:justify-start gap-x-2 gap-y-2">
                  <button
                    onClick={openCalendar}
                    className="px-3 py-1 contained"
                  >
                    Get A Demo
                  </button>
                  <a
                    href={TalkToSupport}
                    className="text-sm font-semibold leading-6 text-[#06526d]"
                  >
                    <button className="text">Start for free</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <GoogleCalendarWidget
        open={isCalendarOpen}
        setOpen={setIsCalendarOpen}
        />
    </div>
      
      </>
  );
}
